/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Warm_Otter_RestInputs */

const en_calm_warm_otter_rest = /** @type {(inputs: Calm_Warm_Otter_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoters`)
};

const de_calm_warm_otter_rest = /** @type {(inputs: Calm_Warm_Otter_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotoren`)
};

/**
* | output |
* | --- |
* | "Promoters" |
*
* @param {Calm_Warm_Otter_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_warm_otter_rest = /** @type {((inputs?: Calm_Warm_Otter_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Warm_Otter_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_warm_otter_rest(inputs)
	return de_calm_warm_otter_rest(inputs)
});